var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "schedule-flow__success" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "schedule-flow__success-content" }, [
        _c("div", { staticClass: "schedule-flow__success-title" }, [
          _vm._v(
            _vm._s(
              _vm.locales.appointments &&
                _vm.locales.appointments.viewing_scheduled
            )
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "schedule-flow__success-text" }, [
          _vm._v(
            _vm._s(
              _vm.locales.appointments &&
                _vm.locales.appointments.you_will_receive_confirmation_mail
            ) + " "
          ),
          _c("br"),
          _vm._v(
            _vm._s(
              _vm.locales.appointments &&
                _vm.locales.appointments.we_will_send_you_reminder
            ) + "\n      "
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "schedule-flow__results" }, [
      _c("div", { staticClass: "mb-9" }, [
        _c("div", { staticClass: "schedule-flow__results-title" }, [
          _vm._v(
            _vm._s(_vm.locales.appointments && _vm.locales.appointments.guests)
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "schedule-flow__results-value" }, [
          _vm._v(
            _vm._s(_vm.subscription.tenants.length) +
              " " +
              _vm._s(
                _vm.subscription.tenants.length > 1
                  ? _vm.locales.appointments && _vm.locales.appointments.guests
                  : _vm.locales.appointments && _vm.locales.appointments.guest
              )
          )
        ])
      ]),
      _vm._v(" "),
      _vm.subscription && _vm.subscription.tenants
        ? _c("div", { staticClass: "theme-table__wrap mb-9" }, [
            _c("table", { staticClass: "theme-table" }, [
              _c(
                "tbody",
                _vm._l(_vm.subscription.tenants, function(user, index) {
                  return _c("tr", { key: index }, [
                    _c("td", [_vm._v(_vm._s(user.fullNameWithTitle))]),
                    _vm._v(" "),
                    _c("td", [_vm._v("€ " + _vm._s(user.income))])
                  ])
                }),
                0
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "mb-9" }, [
        _c("div", { staticClass: "schedule-flow__results-title" }, [
          _vm._v(
            _vm._s(
              _vm.locales.appointments && _vm.locales.appointments.date_and_time
            )
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "schedule-flow__results-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.date.selectedDate))]),
          _vm._v(" "),
          _c("span", [_vm._v("●")]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.time))]),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "schedule-flow__results-link",
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.edit.apply(null, arguments)
                }
              }
            },
            [_vm._v(_vm._s(_vm.locales.common && _vm.locales.common.edit))]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "schedule-flow__success-icon-holder" }, [
      _c("i", { staticClass: "icon-check" })
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f20f90b6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f20f90b6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/ScheduleFlowConfirmation.vue
// module id = 698
// module chunks = 1